import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TextareaAutosize, Button } from "@mui/material";
import ErrorAlert from "../../../toolkit/ErrorAlert";

export default function FormulaReferenceTable({
  questionsAndCodes,
  existingFormula,
  onFormulaVerifySuccess,
}) {
  const [inputFormula, setInputFormula] = useState(existingFormula ?? "");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const maxNoOfCodes = Math.max(
    ...questionsAndCodes.map((item) => item.codes.length)
  );

  const updatedQuestionsAndCodes = questionsAndCodes.map((item) => {
    if (item.codes.length !== maxNoOfCodes) {
      const missingCodes = maxNoOfCodes - item.codes.length;
      return {
        ...item,
        codes: item.codes.concat(Array(missingCodes).fill("-")),
      };
    }
    return item;
  });

  const changeInputFormula = (e) => {
    const value = e.target.value;
    const sanitizedValue = value.replace(/[^0-9+\-*/Q()]/g, ""); // Allow numbers, "+", "-", "*", "/", "Q", "(", and ")"
    setInputFormula(sanitizedValue);
  };

  const VerifyFormula = () => {
    var SplitVals = inputFormula
      .replace(/\+/g, " ")
      .replace(/-/g, " ")
      .replace(/\*/g, " ")
      .replace(/\//g, " ")
      .replace(/\(/g, " ")
      .replace(/\)/g, " ");
    const QuestionIds = SplitVals.split(" ");

    let formula = inputFormula;
    for (var i = 0; i < QuestionIds.length; i++) {
      //These are questioncolumn ids
      if (QuestionIds[i].indexOf("Q") != -1) {
        formula = formula.replace(QuestionIds[i], "10");
      }
    }

    setError(null);
    setResult(null);

    try {
      setResult(eval(formula));
      onFormulaVerifySuccess(inputFormula);
    } catch (Error) {
      setError("Error in formula");
    }
  };

  return (
    <>
      <div className="row mt-2 px-3">
        <div className="col-sm-9 col-md-9 col-xl-9 mt-2 ">
          <TableContainer
            className="p-0 border rounded mx-2 "
            style={{ height: "400px", overflowY: "auto" }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow className="bg-light">
                  <TableCell>Question</TableCell>
                  {updatedQuestionsAndCodes[0]?.codes?.map((row, index) => (
                    <TableCell key={index}>Code</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {updatedQuestionsAndCodes?.map((row, index) => (
                  <TableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.questionString}
                    </TableCell>

                    {row.codes.map((code, index) => (
                      <TableCell
                        colSpan={maxNoOfCodes.length + 1 - row.codes?.length}
                        key={index}
                      >
                        {code ?? "-"}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="col-sm-3 col-md-3 col-xl-3 mt-2 ">
          <div>
            <TextareaAutosize
              minRows={2}
              id="inputFormula"
              value={inputFormula}
              placeholder="Input Formula"
              size="small"
              className="form-control text-feild-custom"
              onChange={changeInputFormula}
            />
          </div>
          <div className="mt-2 mx-1">
            <span className="text-muted">
              Click on verify button, to check the result with input value of
              each question as 10
            </span>
          </div>
          {result && (
            <div className="mt-2 mx-1">
              <ErrorAlert message={result} severity="success" />
            </div>
          )}
          {error && (
            <div className="mt-2 mx-1">
              <ErrorAlert message={error} />
            </div>
          )}
          <div className="mt-3 mx-1">
            <Button
              variant="contained"
              color="primary"
              className="light-blue-button shadow-none w-100"
              onClick={VerifyFormula}
              size="large"
              style={{ textTransform: "capitalize", padding: "15px" }}
            >
              Verify
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
